// packages/web/src/components/onboarding/onboarding-choice.tsx
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export interface OnboardingChoiceProps {
  name: string;
  hasPendingMicrosoftHint: boolean;
  onMicrosoft: () => void;
  onPasswordChosen: () => void;
}

export function OnboardingChoice({
  name,
  hasPendingMicrosoftHint,
  onMicrosoft,
  onPasswordChosen,
}: OnboardingChoiceProps) {
  const { t } = useTranslation();
  const microsoftFirst = hasPendingMicrosoftHint;
  const microsoftBlock = (
    <Button variant="primary" className="w-full" onClick={onMicrosoft}>
      {t("onboarding.choice.microsoft.label")}
    </Button>
  );
  const passwordBlock = (
    <Button variant="default" className="w-full" onClick={onPasswordChosen}>
      {t("onboarding.choice.password.label")}
    </Button>
  );

  return (
    <div className="mx-auto max-w-md space-y-4 p-6">
      <h1 className="text-xl font-semibold text-ink-900">
        {t("onboarding.choice.title", { name })}
      </h1>
      <p className="text-[13px] text-ink-700">{t("onboarding.choice.description")}</p>
      <div className="space-y-3">
        {microsoftFirst ? microsoftBlock : null}
        {passwordBlock}
        {microsoftFirst ? null : microsoftBlock}
      </div>
    </div>
  );
}
